import request, { BASE_URL } from './request'

/**
 * 获取新闻列表（L2接口）
 * @param {Object} params - { categoryId, isRecommended, excludeNewsIdList, pageNum, pageSize }
 * @returns {Promise<Object>} { list, total }
 */
export async function fetchNewsListL2(params) {
  const res = await request.post('/api/news/listL2', params)
  const data = res.data || {}
  const list = Array.isArray(data) ? data : (data.records || data.list || data.rows || [])
  const total = data.total || list.length
  return { list, total }
}

/**
 * 将接口返回的新闻对象映射为组件统一格式
 */
export function mapNewsItem(item) {
  return {
    id: item.id || item.newsCode || '',
    newsCode: item.newsCode || item.id || '',
    title: item.title || '',
    desc: item.summary || item.description || item.desc || '',
    img: resolveImageUrl(item.coverImage || item.imageUrl || item.cover || item.img || ''),
    category: item.categoryName || item.category || '',
    time: formatTime(item.publishTime || item.createTime || item.time),
    source: item.source || item.sourceName || ''
  }
}

function resolveImageUrl(url) {
  if (!url) return ''//require('../assets/images/default/default-news.png')
  if (/^https?:\/\/.*/.test(url)) return url
  return BASE_URL + url
}

/**
 * 收藏/取消收藏新闻
 * @param {String|Object} newsIdOrParams - 新闻ID 或 { newsId } / { newsCode }
 * @param {Number} status - 1收藏 0取消收藏
 */
export async function favoriteNews(newsIdOrParams, status = 1) {
  let params = {}
  if (typeof newsIdOrParams === 'object' && newsIdOrParams !== null) {
    params = newsIdOrParams
  } else {
    params = { newsId: newsIdOrParams, status }
  }
  const res = await request.post('/api/member/newsFavorite/favorite', params)
  return res
}

/**
 * 获取新闻正文内容
 */
export async function fetchNewsContent(id) {
  const res = await request.post('/api/news/content', { id })
  return res.data || {}
}

/**
 * 搜索新闻
 */
export async function searchNews(query, pageNum = 1, pageSize = 1000) {
  const res = await request.post('/api/news/search', { query, pageNum, pageSize })
  const data = res.data || {}
  const list = Array.isArray(data) ? data : (data.rows || data.list || data.records || [])
  return list
}

/**
 * 获取频道列表
 * @param {Number} type - 1.个人 2.企业
 */
export async function getCategoryList(type) {
  const res = await request.get('/api/category/getList', { params: { type } })
  return res.data || []
}

/**
 * 提交反馈意见
 * @param {Object} data - 反馈数据
 */
export async function submitFeedback(data) {
  const res = await request.post('/api/feedback/add', data)
  return res.data || {}
}

function formatTime(time) {
  if (!time) return ''
  // 如果已经是格式化字符串直接返回
  if (typeof time === 'string' && time.length <= 20) return time
  try {
    const d = new Date(time)
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
  } catch (e) {
    return String(time)
  }
}

/**
 * 获取验证码图片
 */
export async function getCaptchaImage() {
  const res = await request.get('/api/captchaImage')
  return res.data || {}
}
